module.exports = __webpack_public_path__ + "static/media/MykalaSandifer.892348fd.jpg";